"use strict";

exports.__esModule = true;
exports.ShiftSelector = ShiftSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.name;
}
function renderItemText(input) {
  return input.name;
}

/**
 * Allows a user to select shift(s) from a list.
 */
function ShiftSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: props.multiple ? translate("ShiftSelector.placeholder.multiple", "Select Shifts") : translate("ShiftSelector.placeholder.single", "Select Shift"),
      getKey: getKey,
      renderItemText: renderItemText,
      filterable: false,
      width: 275
    }, props));
  });
}